import React from 'react'
import PropTypes from 'prop-types'
import { Typography } from 'antd'

const { Text } = Typography
const DEFAULT_HREF =
  'mailto:atendimento@gcmgames.com.br?subject=Preciso de ajuda com meu pedido&body=Explique aqui o seu problema:'

export function GenericHelp({ href }) {
  const hrefToUse = href || DEFAULT_HREF

  return (
    <a href={hrefToUse} target='_blank' rel='noopener noreferrer'>
      <Text>
        Precisa de ajuda? <strong>Clique aqui</strong>
      </Text>
    </a>
  )
}

GenericHelp.propTypes = {
  /** A custom href to be used on the help anchor */
  href: PropTypes.string,
}
